import {
  FETCH_ANALYTICS_SUMMARY_START,
  FETCH_ANALYTICS_SUMMARY_SUCCESS,
  FETCH_ANALYTICS_SUMMARY_FAILURE,
  FETCH_ACTIVITY_LOGS_START,
  FETCH_ACTIVITY_LOGS_SUCCESS,
  FETCH_ACTIVITY_LOGS_FAILURE,
  SET_ANALYTICS_FILTERS,
  FETCH_ALL_USERS_START,
  FETCH_ALL_USERS_SUCCESS,
  FETCH_ALL_USERS_FAILURE,
  FETCH_API_VOLUME_INTERVAL_REQUEST,
  FETCH_API_VOLUME_INTERVAL_SUCCESS,
  FETCH_API_VOLUME_INTERVAL_FAIL
} from '../action-type';
import {
  fetchAnalyticsSummary,
  fetchActivityLogs,
  fetchAllUsers as fetchAllUsersService,
  fetchApiVolumeByInterval as fetchApiVolumeByIntervalService
} from '../../services/analyticsService';

export const setAnalyticsFilters = (filters) => ({
  type: SET_ANALYTICS_FILTERS,
  payload: filters,
});

export const fetchAnalyticsData = (filters) => async (dispatch) => {
  dispatch({ type: FETCH_ANALYTICS_SUMMARY_START });
  try {
    const summaryRes = await fetchAnalyticsSummary(filters);
    dispatch({
      type: FETCH_ANALYTICS_SUMMARY_SUCCESS,
      payload: summaryRes.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ANALYTICS_SUMMARY_FAILURE,
      payload: error,
    });
  }
};

export const fetchLogs = (page, perPage, filters) => async (dispatch) => {
  dispatch({ type: FETCH_ACTIVITY_LOGS_START });
  try {
    const logsRes = await fetchActivityLogs(page, perPage, filters);
    dispatch({
      type: FETCH_ACTIVITY_LOGS_SUCCESS,
      payload: logsRes.data,
    });
  } catch (error) {
    dispatch({
      type: FETCH_ACTIVITY_LOGS_FAILURE,
      payload: error,
    });
  }
};

export const fetchAllUsers = () => async (dispatch) => {
    dispatch({ type: FETCH_ALL_USERS_START });
    try {
        const res = await fetchAllUsersService();
        dispatch({ type: FETCH_ALL_USERS_SUCCESS, payload: res.data });
    } catch (error) {
        dispatch({ type: FETCH_ALL_USERS_FAILURE, payload: error });
    }
};

export const fetchApiVolumeByInterval = (interval = 3600, filters = {}) => async dispatch => {
  try {
    dispatch({ type: FETCH_API_VOLUME_INTERVAL_REQUEST });

    const res = await fetchApiVolumeByIntervalService(interval, filters);

    dispatch({
      type: FETCH_API_VOLUME_INTERVAL_SUCCESS,
      payload: res.data,
    });

  } catch (err) {
    dispatch({
      type: FETCH_API_VOLUME_INTERVAL_FAIL,
      payload: err.message,
    });
  }
};
